import { Grid } from "@mui/material";
import axios from "axios";
import React, { useEffect } from "react";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import { toast, ToastContainer } from "react-toastify";
// import CustomDataGrid from "../../../components/CustomDataGrid/CustomDataGrid.tsx";
import CustomDataGrid from "./../../../components/CustomDataGrid/CustomDataGrid.tsx";
import searchIcon from "./../../../../assets/icons/search.ico";
import bin from "./../../../../assets/icons/reject.png";
import edit from "./../../../../assets/icons/edit.png";
import linkactiveImg from "./../../../../assets/images/linkActive.png";
import linkDeactiveImg from "./../../../../assets/images/linkDective.png";
import approveImg from "./../../../../assets/icons/checked.png";
// import LoadingView from "../../../components/LoadingView/LoadingView.js";
import LoadingView from "./../../../components/LoadingView/LoadingView.js";
import { useMemo } from "react";
import CancelationReasonBankDetailsDialogDeliveryManDeliveryMan from "./CancelationReasonDialogForDeliveryMan/CancelationReasonBankDetailsDialogDeliveryMan.tsx";

const BankDetailsDeliveryMan = () => {
  const [selectedData, setSelectedData] = React.useState([]);
  const [dataRows, setDataRows] = React.useState([]);
  const columnsdatas = [
    {
      field: "restaurantName",
      headerName: "Restaurant Name",
      align: "center",
      renderCell: (params) => (
        <div
          className="d-flex align-items-center justify-content-center"
          style={{ gap: "5px", cursor: "pointer" }}
        >
          <span style={{ color: "blue", cursor: "pointer" }}>
            {params.value}
          </span>
        </div>
      ),
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "accountHolderName",
      headerName: "Account Holder Name",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "accountNumber",
      headerName: "Account Number",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "sortCode",
      headerName: "Sort Code",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "iban",
      headerName: "IBAN",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "createdByUserName",
      headerName: "Amount",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "isApproveByAdmin",
      headerName: "Status",
      renderCell: useMemo(
        () => (params) => {
          return (
            <div
              className={`${
                params.value == "f07294b7-c94d-4d5e-a064-b1282d5b5434"
                  ? "approve"
                  : params.value == "f07294b7-c94d-4d5e-a064-b1282d5b543b" ||
                      params.value == "f07294b7-c94d-4d5e-a064-b1282d5b5411"
                    ? "pending"
                    : "reject"
              } RoundedStatus`}
            >
              {params.value == "f07294b7-c94d-4d5e-a064-b1282d5b5434"
                ? "Approve"
                : params.value == "f07294b7-c94d-4d5e-a064-b1282d5b543b"
                  ? "Pending"
                  : params.value == "f07294b7-c94d-4d5e-a064-b1282d5b5411"
                    ? "Resubmitted"
                    : "Reject"}
            </div>
          );
        },
        [],
      ),
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
  ];
  const apiAddress = process.env.REACT_APP_SECRET;
  const [enableOptions, setEnableOptions] = React.useState(false);
  const typrOfMenuDatas = [
    { id: 1, title: "Online" },
    { id: 2, title: "In-store" },
    // { id: 3, title: 'Cor' },
    // { id: 3, title: 'Add Type' },
  ];
  const [autoCompleteValue, setAutoCompleteValue] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [clickedRestaurant, setClickedRestaurant] = React.useState("");
  const [loadingModal, SetloadingModal] = React.useState(false);
  const [openCancelReasonDialog, setopenCancelReasonDialog] =
    React.useState(false);
  const [clickedRestaurantDetails, setClickedRestaurantDetails] =
    React.useState([]);
  const [allRestaurantDetails, setAllRestaurantDetails] = React.useState([]);

  const getselectedData = (props) => {
    var temp = props;
    setSelectedData(temp);
    if (props.length > 0) {
      setEnableOptions(true);
    } else {
      setEnableOptions(false);
    }
  };

  const addValue = (props) => {
    setAutoCompleteValue(props);
  };

  const handleClickOpen = (props) => {
    setOpen(true);
    var data = dataRows.find((x) => x.companyLegalName === props);
    console.log("data: " + data.companyLegalName);
    setClickedRestaurant(data);
  };

  const handleAddItem = (AddItemData) => {
    setOpen(AddItemData);
    loadData();
  };

  const handleClickopenCancelReasonDialog = () => {
    setopenCancelReasonDialog(true);
    var tempData = [];
    var allTempData = [];
    selectedData.map((data, index) => {
      var dt = dataRows.find((x) => x.id === data);
      var obj = {
        id: dt.id,
        title: dt.companyLegalName,
      };
      tempData.push(obj);
    });

    dataRows.map((dt, index) => {
      var obj = {
        id: dt.id,
        title: dt.companyLegalName,
      };
      allTempData.push(obj);
    });
    setAllRestaurantDetails(allTempData);
    console.log("tempData: " + tempData[0].title);
    setClickedRestaurantDetails(tempData);
  };

  const handleAddopenCancelReasonDialog = (AddItemData) => {
    setopenCancelReasonDialog(AddItemData);
    loadData();
  };

  const [loading, setloading] = React.useState(false);

  const [dataLoaded, setdataLoaded] = React.useState(false);

  React.useEffect(() => {
    loadData();
  }, []);

  const approvedData = async (props) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>You want to approve this?</p>
            <button onClick={onClose} className="btn-no btn-common">
              No
            </button>
            <button
              className="btn-yes btn-common"
              onClick={() => {
                // this.handleClickDelete();
                approve(props);
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
    });
  };

  const activeLinkData = async (props, text) => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="custom-ui">
            <h1>Are you sure?</h1>
            <p>{text}</p>
            <button onClick={onClose} className="btn-no btn-common">
              No
            </button>
            <button
              className="btn-yes btn-common"
              onClick={() => {
                // this.handleClickDelete();
                approve(props);
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
    });
  };

  const approve = async (props) => {
    const token = localStorage.getItem("gotasteadmintoken");

    console.log(selectedData);

    if (token) {
    } else {
      window.location.href = "/login";
    }
    setloading(true);
    SetloadingModal(true);

    await axios({
      method: "put",
      url:
        apiAddress +
        "/api/RestaurantBankDetails/updateStatusByMultipleBankDetailsIds",
      data: selectedData,
    })
      .then(function (response) {
        setloading(false);
        SetloadingModal(false);
        console.log(response);
        toast.success("Successfully Saved", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        loadData();

        // Resetting selected State
        setSelectedData([]);
        setEnableOptions(false);
      })
      .catch(function (error) {
        setloading(false);
        SetloadingModal(false);
        console.log(error);
        toast.error("Error" + error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });

    // SetloadingModal(false);
  };

  const loadData = async () => {
    const token = localStorage.getItem("gotasteadmintoken");

    if (token) {
    } else {
      window.location.href = "/login";
    }
    axios({
      method: "get",
      url: apiAddress + "/api/RestaurantBankDetails",
      headers: {
        Authorization: "Bearer " + token,
      },
    })
      .then(function (response) {
        console.log(response.data);
        setDataRows(response.data);
        var state = false;
        setdataLoaded(state);
      })
      .catch(function (error) {});
  };

  const closeLoadingModal = () => {
    SetloadingModal(false);
  };

  const pendingRequests = dataRows?.filter(
    (x) => x?.approvalStatusDescription === "Pending",
  );

  const approvedRequests = dataRows?.filter(
    (x) => x?.approvalStatusDescription === "Approved",
  );

  const linkActivated = dataRows?.filter(
    (x) => x?.approvalStatusDescription === "Link Activated",
  );

  console.log("data rows", dataRows);

  return (
    <div className="w-100 p-3">
      <LoadingView open={loadingModal} close={closeLoadingModal} />
      <ToastContainer />{" "}
      <Grid
        container
        alignItems="center"
        justifyContent="space-between"
        mt={2}
        mb={2}
      >
        {/* Approve Button */}
        <Grid item>
          <Grid container spacing={2} alignItems="center">
            <Grid item>
              <div
                className={` ${enableOptions ? "" : "disable"}  roundedCorner`}
                onClick={() => {
                  approvedData(1);
                }}
              >
                <img src={approveImg} alt="" style={{ width: "1rem" }} />{" "}
                Approve
              </div>
            </Grid>
            <Grid item>
              <div
                className={` ${enableOptions ? "" : "disable"}  roundedCorner`}
                onClick={() => {
                  handleClickopenCancelReasonDialog();
                }}
              >
                <img src={bin} alt="" style={{ width: "1rem" }} /> Reject
              </div>
            </Grid>
          </Grid>
        </Grid>

        {/* Reject Button */}
        <Grid item>
          <Grid container flexDirection={"column"} alignItems={"center"}>
            <Grid item>
              <img src={searchIcon} alt="" style={{ width: "1rem" }} />
            </Grid>
            <Grid item>Search</Grid>
          </Grid>
        </Grid>
      </Grid>
      {dataRows.length > 0 ? (
        <CustomDataGrid
          columns={columnsdatas}
          dataRows={dataRows}
          getselectedData={getselectedData}
          selectedRows={selectedData}
          isLoading={loading}
        />
      ) : (
        "Nothing found"
      )}
      <CancelationReasonBankDetailsDialogDeliveryManDeliveryMan
        open={openCancelReasonDialog}
        onClose={handleAddopenCancelReasonDialog}
        dialogName={"Add On"}
        restaurantName={clickedRestaurantDetails}
        allRestaurant={allRestaurantDetails}
        from={1}
        setEnableOptions={setEnableOptions}
        setSelectedData={setSelectedData}
      />
    </div>
  );
};

export default BankDetailsDeliveryMan;
